import { useMutation } from '@tanstack/react-query';
import useProjectSystem from '@projects/systems/useProjectSystem';

type UseUpdateViewOnlyLinkEnabledMutationParams = {
	projectID: number;
	onSuccess?: ( enabled: boolean ) => void;
};

const useUpdateViewOnlyLinkEnabledMutation = ( {
	projectID, onSuccess
}: UseUpdateViewOnlyLinkEnabledMutationParams ) => {
	const system = useProjectSystem();

	return useMutation(
		( enabled: boolean ) => system.updateProjectPermissions( {
			projectID,
			permissions: { view_only_link_enabled: enabled }
		} ),
		{ onSuccess: ( _, enabled ) => onSuccess?.( enabled ) }
	);
};

export default useUpdateViewOnlyLinkEnabledMutation;
